import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AffiliateGaidMirror.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CustomerIoPageTracker.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/MainComponent.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppContextProvider"] */ "/app/src/context/AppContext.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["GameContextProvider"] */ "/app/src/context/GameContext.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/landing.scss");
;
import(/* webpackMode: "eager" */ "/app/src/styles/main_styles.scss");
